import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { BcacCommonTableComponent } from './bcac-common-table/bcac-common-table.component';
import { BcacIconModule } from 'bcac-lib/base-component/currency/bcac-icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BcacPipe } from './bcac.pipe';
// import { BcacLibModule } from 'bcac-lib';



@NgModule({
  declarations: [BcacCommonTableComponent, BcacPipe],
  imports: [
    CommonModule,
    FormsModule,
    NgZorroAntdModule,
    BcacIconModule,
  ], exports: [
    BcacCommonTableComponent
  ]
})
export class BcacTableModule { }
